import React from "react";
import { FaCode, FaDesktop, FaLaptopCode } from "react-icons/fa";

const Services = () => {
  return (
    // <!-- ========== Service section start ========== -->
    <div className="service section-padding" id="service">
      <div className="container">
        <div className="row">
          <div
            className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="section-title-center text-center">
              <span>Service</span>
              <h2 className="display-6">Awesome Services</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-lg-4 col-md-6 mb-4 mb-lg-0"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="100"
          >
            <div className="service__item h-100">
              <div className="icon">
                <FaCode />
              </div>
              <h3>Full Stack Developer</h3>
              <p>
                A full-stack developer is a programmer who has experience and
                expertise in working on both the front-end and back-end of a web
                application. I built a web application from the ground up, from
                the user interface to the database and server-side programming.
              </p>
            </div>
          </div>
          <div
            className="col-lg-4 col-md-6 mb-4 mb-lg-0"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="service__item h-100">
              <div className="icon">
                <FaLaptopCode />
              </div>
              <h3>Front End Developer</h3>
              <p>
                As a front-end developer, I am responsible for creating the
                visual elements and user interface of a website or application.
                I work with React, & Next to develop the look and feel of the
                website, including the layout, colors, typography, and graphics.
              </p>
            </div>
          </div>
          <div
            className="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="300"
          >
            <div className="service__item h-100">
              <div className="icon">
                <FaDesktop />
              </div>
              <h3>Web Designer</h3>
              <p>
                As a web designer, I am responsible for designing the visual
                elements of a website, including the layout, typography, and
                colors. I work with various design tools such as Adobe
                Photoshop, and Figma for the website's design.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    // <!-- ========== Service section start ========== -->
  );
};

export default Services;
